import axios from "axios";
import { toast } from 'react-toastify';
import { api } from "./api";

const BASE_URL = process.env.REACT_APP_API_URL 

const apiClient = axios.create({
    baseURL: BASE_URL,
    headers:{
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    },
});

apiClient.interceptors.request.use(
    (config) =>{
        const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData){
      delete config.headers['Content-Type'];
    }
    return config;
    },
    (error) => {
      toast.error('Request failed to send. Please check your connection.');
      return Promise.reject(error);
    }
);

apiClient.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
        toast.error(error.response?.data?.message || "Something went wrong.");
        if (error.response?.status === 401) {
          setTimeout(()=>{
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            window.location.href = '/login';
          },2000);
        }else {
          console.log(error)
          // toast.error(error.response?.data?.message || "Something went wrong.");
      }
        return Promise.reject(error);
    }
);

export default apiClient;